import { gql } from '@apollo/client';
import EducationHistoryFragment from '@/apollo/fragments/Portfolio/PortfolioEducationHistory.fragment';

const EducationHistoryQuery = gql`
  ${EducationHistoryFragment}

  query PublicPortfolioEducationHistory($id: ID!) {
    educationHistory(id: $id) {
      ...EducationHistoryFragment
      fieldOfStudy
    }
  }
`;

export default EducationHistoryQuery;
